import styled from 'styled-components';
import { getIcon } from 'styles/icons';
import { Theme, getColor } from 'styles/theme';

const Wrapper = styled.ul<{ theme: Theme }>`
  text-align: center;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;

  li {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
    margin: 0 4px;

    button {
      ${getIcon('bullet')}
    }

    &.slick-active {
      button {
        &::before {
          background: ${getColor('iconAccentPrimary')};
        }
      }
    }
  }
`;

export default Wrapper;
